import { CssBaseline, ThemeProvider as MUIThemeProvider } from '@mui/material'
import { createCustomTheme } from '@src/contexts/theme-context'
import { useMemo, type JSX } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  children: JSX.Element
}

const ThemeProvider = ({ children }: Props) => {
  const {
    i18n: { resolvedLanguage },
  } = useTranslation()
  const customTheme = useMemo(() => createCustomTheme(resolvedLanguage), [resolvedLanguage])

  if (!customTheme) return null

  return (
    <MUIThemeProvider theme={customTheme}>
      <CssBaseline />
      {children}
    </MUIThemeProvider>
  )
}

export default ThemeProvider
